import React from 'react';
import Seat from '../../../components/Seat';
import WagonDoor from '../../../components/WagonDoor';
import WagonToilet from '../../../components/WagonToilet';

function FirstFloor({
  seats, chosenSeats, setChosenSeats, wagonNumber, unReserveSeat, reserveSeat,
}) {
  return (
    <div>
      <div className="wagon">
        <div className="wagon-floor">
          <h2>I</h2>
        </div>
        <div
          className="seats-row left "
          style={{ width: '755.3px', marginLeft: '40px' }}
        />
        <div
          className="seats-row left"
          style={{ marginLeft: '60px' }}
        >
          <WagonDoor />
          <WagonToilet />
          {
              [
                [32, 31, 30, 29],
                [28, 27, 26, 25],
                [24, 23, 22, 21],
                [20, 19, 18, 17],
                [16, 15, 14, 13],
                [12, 11, 10, 9],
                [8, 7, 6, 5],
                [4, 3, 2, 1],
              ].map((seatsPair, index) => (
                <React.Fragment key={seatsPair[0]}>
                  <div className="seat-column relative">
                    {!index && <div className="border border-solid w-[1px] h-[110px] -bottom-2 absolute left-0.5" />}
                    <Seat
                      seat={seats?.[seatsPair[0]]}
                      chosenSeats={chosenSeats}
                      setChosenSeats={setChosenSeats}
                      wagonNumber={wagonNumber}
                      reserveSeat={reserveSeat}
                      unReserveSeat={unReserveSeat}
                      noDirection
                      hidePrice
                    />
                    <Seat
                      seat={seats?.[seatsPair[1]]}
                      chosenSeats={chosenSeats}
                      setChosenSeats={setChosenSeats}
                      wagonNumber={wagonNumber}
                      reserveSeat={reserveSeat}
                      unReserveSeat={unReserveSeat}
                      noDirection
                      hidePrice
                      bottom
                    />
                  </div>
                  <div className="seat-column  reversed relative">
                    <Seat
                      seat={seats?.[seatsPair[3]]}
                      chosenSeats={chosenSeats}
                      setChosenSeats={setChosenSeats}
                      wagonNumber={wagonNumber}
                      reserveSeat={reserveSeat}
                      unReserveSeat={unReserveSeat}
                      noDirection
                      hidePrice
                    />
                    <Seat
                      seat={seats?.[seatsPair[2]]}
                      chosenSeats={chosenSeats}
                      setChosenSeats={setChosenSeats}
                      wagonNumber={wagonNumber}
                      reserveSeat={reserveSeat}
                      unReserveSeat={unReserveSeat}
                      noDirection
                      hidePrice
                      bottom
                    />
                  </div>
                  <div className="relative">
                    <div className="border border-solid w-[1px] h-[110px] -bottom-2 absolute -right-1" />
                  </div>

                </React.Fragment>
              ))
          }
          <WagonDoor className="!ml-2" />
        </div>
      </div>
    </div>
  );
}

export default FirstFloor;
